module.exports = __webpack_public_path__ + "img/undraw_online_resume_re_ru7s.63a5ec4c.svg";